export const SNAPSHOT_MANAGER_KEY = 'rumSnapshotManager';
export const INITIAL_SNAPSHOT_CONTEXT = {
    errorCount: 0,
    viewCount: 0,
    actionCount: 0,
    hasRecording: false,
};
